// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { TemporaryBackofficeSessionsAreaId } from './TemporaryBackofficeSessionsAreaId'
import {
  TemporaryBackofficeSessionsAreaNavigation,
  TemporaryBackofficeSessionsAreaNavigationIcon,
} from './TemporaryBackofficeSessionsAreaNavigation'
import { TemporaryBackofficeSessionsAreaRoutes } from './TemporaryBackofficeSessionsAreaRoutes'

const LazyTemporaryBackofficeSessionsComponent = lazy(
  () => import('./TemporaryBackofficeSessionsArea'),
)

const TemporaryBackofficeSessionsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyTemporaryBackofficeSessionsComponent />
  </SuspenseLoadingWrapper>
)

export const TemporaryBackofficeSessionsArea = {
  id: TemporaryBackofficeSessionsAreaId,
  requiredRight: BoumRight.TEMPORARY_BACKOFFICE_SESSIONS,
  Icon: TemporaryBackofficeSessionsAreaNavigationIcon,
  NavigationComponent: TemporaryBackofficeSessionsAreaNavigation,
  route: {
    path: TemporaryBackofficeSessionsAreaRoutes.route,
    component: TemporaryBackofficeSessionsComponent,
  },
}
